module.exports = __webpack_public_path__ + "static/media/support.96277461.svg";